'use client'

import { useSidebar } from '@repo/ui/components'
import { useMemo } from 'react'

import { ILogoProps } from './interaface.ts'

// Logo component that adapts based on whether the drawer is open and user type
export const SideBarLogo = ({ CloseLogo, OpenLogo }: ILogoProps) => {
  const { open } = useSidebar()

  const openStyle = useMemo(
    () => ({
      height: '100%',
      marginRight: 'auto',
      paddingRight: open ? '12px' : 'auto',
      width: 'auto',
    }),
    [open],
  )

  const closeStyle = { height: '100%', width: '100%' }

  return open ? <OpenLogo style={openStyle} /> : <CloseLogo style={closeStyle} />
}
